export default {
  DOMAIN: 'domain',
  TERM: 'term',
  INITIATOR: 'initiator',
  PREMIUM_FEATURE: 'premiumFeature',
  PREFILL: 'prefill',
  PRODUCTS: 'products',
  TRIGGER_ID: 'triggerId',
  ACTION_ID: 'actionId',
  BACK: 'back',
  PERIOD_TOGGLE: 'periodToggle',
  PAYMENT_BACK_URL: 'paymentBackUrl',
  RESCHEDULE_SUBSCRIPTION: 'rescheduleSubscription',
  PROMO_CAMPAIGN_ID: 'promoCampaignId',
};
